import { useRef } from 'react';

function useSpringConfig({
  animationDelay = 0,
  shouldAnimate = true,
  mountedSpringConfig,
  unmountedSpringConfig
}) {
  const isMounted = useRef(false);
  const delay = shouldAnimate ? animationDelay : 0;
  return {
    config: isMounted.current ? mountedSpringConfig : unmountedSpringConfig,
    default: {
      immediate: !shouldAnimate
    },
    delay: isMounted.current ? 0 : delay,
    onRest: () => isMounted.current = true
  };
}

export { useSpringConfig };
